/** When your routing table is too long, you can split it into small modules **/

import AuthLayout from '@/layout/AuthLayout';

const requestDemoLayoutRouter = {
  path: '/request',
  component: AuthLayout,
  redirect: '/request-demo',
  hidden: true,
  meta: {
    title: 'Request',
    icon: 'component'
  },
  children: [
    {
      path: '/request-demo',
      component: () => import('@/views/request-demo/RequestDemo'),
      name: 'RequestDemo',
      meta: {
        title: 'Solicitud para Demostración',
        icon: 'mdi-view-dashboard-outline',
        affix: true
      }
    }
  ]
};

export default requestDemoLayoutRouter;
